import { api_DELETE, api_GET, api_POST, api_PUT } from "./_api.js";

const roteiroDeFiscalizacao_api = {
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`RoteiroFiscalizacao`)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`RoteiroFiscalizacao/GetItem/${id}`)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    GetAllFiscalizacaoEtapas: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`RoteiroFiscalizacao/GetAllFiscalizacaoEtapas/`)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("RoteiroFiscalizacao/PostRoteiroFiscalizacao", json)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (roterioDeFiscalizacao) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("RoteiroFiscalizacao/PutRoteiroFiscalizacao", roterioDeFiscalizacao)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    postRoteiroFiscalizacaoEtapa: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`RoteiroFiscalizacao/PostRoteiroFiscalizacaoEtapa`, json)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    putRoteiroFiscalizacaoEtapa: (roteiroFiscalizacaoEtapa) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`RoteiroFiscalizacao/PutRoteiroFiscalizacaoEtapa`, roteiroFiscalizacaoEtapa)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    DeleteRoteiroFiscalizacaoEtapa: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`RoteiroFiscalizacao/DeleteRoteiroFiscalizacaoEtapa/${id}`)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    PostRoteiroFiscalizacaoAcao: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`RoteiroFiscalizacao/PostRoteiroFiscalizacaoAcao`, json)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    PutRoteiroFiscalizacaoAcao: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`RoteiroFiscalizacao/PutRoteiroFiscalizacaoAcao`, json)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    DeleteRoteiroFiscalizacaoAcao: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`RoteiroFiscalizacao/DeleteRoteiroFiscalizacaoAcao/${id}`)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default roteiroDeFiscalizacao_api;
